// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as LoadAssistInfoApiModel from "../api-model/LoadAssistInfoApiModel.bs.js";

function parseItemDetails(itemDetailsJson) {
  var catalogItems = LoadAssistInfoApiModel.catalog_items_decode(itemDetailsJson);
  if (catalogItems.TAG === /* Ok */0) {
    var catalogItems$1 = catalogItems._0;
    var cartonItems = Belt_Array.map(catalogItems$1.items, (function (item) {
            return {
                    carton_type: item.type_,
                    dimension: item.build_type,
                    count: item.count
                  };
          }));
    return [
            catalogItems$1.service_info.description,
            catalogItems$1.service_info.partner_count,
            cartonItems
          ];
  }
  var otherItems = LoadAssistInfoApiModel.other_items_decode(itemDetailsJson);
  if (otherItems.TAG !== /* Ok */0) {
    return [
            "",
            1,
            undefined
          ];
  }
  var otherItems$1 = otherItems._0;
  return [
          otherItems$1.service_info.description,
          otherItems$1.service_info.partner_count,
          undefined
        ];
}

function apiModelToEntity(apiModel) {
  var orderInfo = Belt_Array.get(apiModel.order_info, 0);
  if (orderInfo === undefined) {
    return ;
  }
  var match = parseItemDetails(orderInfo.item_info.item_details);
  var cartonItems = match[2];
  var desc = orderInfo.item_info.load_description;
  var goodsType = /^\d+\s+items?$/i.test(desc) ? (
      cartonItems !== undefined ? Belt_Array.map(cartonItems, (function (item) {
                  var weightRange = item.dimension.replace(/\s+/g, "");
                  return "[" + weightRange + "]: " + String(item.count);
                })).join(" || ") : ""
    ) : desc;
  var pickupLocation = Belt_Array.getBy(orderInfo.location_info, (function (loc) {
          return loc.location_type === "Pickup";
        }));
  var dropLocation = Belt_Array.getBy(orderInfo.location_info, (function (loc) {
          return loc.location_type === "Drop";
        }));
  var pickupFloor = Belt_Option.mapWithDefault(pickupLocation, 0, (function (loc) {
          return loc.floor;
        }));
  var dropFloor = Belt_Option.mapWithDefault(dropLocation, 0, (function (loc) {
          return loc.floor;
        }));
  var pickupLift = Belt_Option.mapWithDefault(pickupLocation, false, (function (loc) {
          return loc.lift_type !== "NoLift";
        }));
  var dropLift = Belt_Option.mapWithDefault(dropLocation, false, (function (loc) {
          return loc.lift_type !== "NoLift";
        }));
  return {
          goods_type: goodsType,
          pickup_floor: pickupFloor,
          drop_floor: dropFloor,
          pickup_lift: pickupLift,
          drop_lift: dropLift,
          no_of_partners: match[1],
          service_type: match[0],
          carton_items: cartonItems
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(LoadAssistInfoApiModel.t_decode(json), "LoadAssistInfoEntityMapper.res"));
}

export {
  parseItemDetails ,
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
